module.exports = __webpack_public_path__ + "img/light.84a31202.png";